import type {LibraryState, Assignment} from "./activity-library";
import {normalizeActivity} from "./normalized-activity";

export type ClassAccessCommand = {type: "class_access"; activityId: string; classId: string; active: boolean; visible: boolean; recipients: {classId: string; studentId: string}[]};
export function classAssociation(s: LibraryState, activityId: string, classId: string) {
  const rows = s.assignments.filter(a => !a.sessionId && a.activityId === activityId && a.targetType === "class" && a.targetId === classId);
  return rows.find(a => a.classAssociation) ?? rows[0];
}
export function associatedWithClass(s: LibraryState, activityId: string, classId: string) {
  const row = classAssociation(s, activityId, classId);
  return row ? row.active !== false : s.assignments.some(a => !a.sessionId && a.activityId === activityId && a.active !== false && a.recipients.some(r => r.classId === classId));
}
export function freeAccess(s: LibraryState, assignment: Assignment, classId: string) {
  if (assignment.sessionId) return true; // Session access remains exclusively controlled by phase 3A.
  const policy = classAssociation(s, assignment.activityId, classId) ?? assignment;
  return policy.active !== false && policy.visible !== false;
}
export function setClassAccess(source: LibraryState, c: ClassAccessCommand, now: string) {
  const s = structuredClone(source);
  const a = s.activities.find(a => a.id === c.activityId);
  if (!a || typeof c.active !== "boolean" || typeof c.visible !== "boolean" || !c.classId || !Array.isArray(c.recipients) || c.recipients.some(r => r.classId !== c.classId || !r.studentId)) throw new Error("Association de classe invalide.");
  if (a.archived && c.active) throw new Error("Restaure l’activité avant de l’associer.");
  const v = s.versions.find(v => v.id === a.id && v.version === a.version)!;
  const visible = c.visible && normalizeActivity(v).capabilities.hasStudentInputs;
  let row = classAssociation(s, a.id, c.classId);
  if (!row) {
    row = {id: `class-access:${encodeURIComponent(a.id)}:${encodeURIComponent(c.classId)}`, activityId:a.id, targetType:"class", targetId:c.classId, recipients:[], assignedAt:now, dueDate:null};
    s.assignments.push(row);
  }
  row.classAssociation = true; row.active = c.active; row.visible = visible;
  for (const r of c.recipients) if (!row.recipients.some(old => old.classId === r.classId && old.studentId === r.studentId)) row.recipients.push({...r});
  return s;
}
